// import historyProvider from './historyProvider';
// import stream from './stream';
import _ from 'lodash';

var last_stream = {};
var ws = new WebSocket('wss://stream.binance.com:9443/ws');
ws.onmessage = (event) => {
  let res = JSON.parse(event.data);
  // console.log(res);
  if (res.e == 'kline') {
    last_stream.callback({
      time: res.k.t,
      open: res.k.o,
      high: res.k.h,
      low: res.k.l,
      close: res.k.c,
      volume: 0, //res.k.v,
    });
  }
};
ws.onopen = () => {
  // let request = {
  //   method: 'SUBSCRIBE',
  //   params: ['btcusdt@kline_1m'],
  //   id: 1,
  // };
  // ws.send(JSON.stringify(request));
};

const intervals = {
  1: '1m',
  3: '3m',
  5: '5m',
  15: '15m',
  30: '30m',
  60: '1h',
  120: '2h',
  240: '4h',
  360: '6h',
  480: '8h',
  720: '12h',
  D: '1d',
  '1D': '1d',
  '3D': '3d',
  W: '1w',
  '1W': '1w',
  M: '1M',
  '1M': '1M',
};

const formatingKline = (i) => {
  return {
    time: i[0],
    open: i[1],
    high: i[2],
    low: i[3],
    close: i[4],
    volume: 0, //i[5],
  };
};

export default class {
  binanceSymbols() {
    return fetch('https://api.binance.com/api/v3/exchangeInfo')
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        // let result = _.filter(json.symbols, (s) => {
        //   return _.includes(s, 'USDT');
        // });
        return json.symbols;
      });
  }
  onReady(cb) {
    this.binanceSymbols()
      .then((symbols) => {
        // console.log(symbols);
        this.symbols = symbols;
        cb({
          // supports_marks: false,
          // supports_timescale_marks: false,
          // supports_time: true,
          supported_resolutions: [
            '1',
            '3',
            '5',
            '15',
            '30',
            '60',
            '120',
            '240',
            '360',
            '480',
            '720',
            '1d',
            // '3d',
          ],
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
    userInput = userInput.toUpperCase();
    onResultReadyCallback(
      this.symbols
        .filter((symbol) => {
          return symbol.symbol.indexOf(userInput) >= 0;
        })
        .map((symbol) => {
          return {
            symbol: symbol.symbol,
            full_name: symbol.symbol,
            description: symbol.baseAsset + ' / ' + symbol.quoteAsset,
            ticker: symbol.symbol,
            //exchange: 'Binance',
            //type: 'crypto'
          };
        })
    );
  }
  resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
    // this.debug && console.log('👉 resolveSymbol:', symbolName);

    // const comps = symbolName.split(':');
    // symbolName = (comps.length > 1 ? comps[1] : symbolName).toUpperCase();

    function pricescale(symbol) {
      for (let filter of symbol.filters) {
        if (filter.filterType == 'PRICE_FILTER') {
          return Math.round(1 / parseFloat(filter.tickSize));
        }
      }
      return 1;
    }

    for (let symbol of this.symbols) {
      if (symbol.symbol == symbolName) {
        setTimeout(() => {
          onSymbolResolvedCallback({
            name: symbol.symbol,
            description: symbol.baseAsset + ' / ' + symbol.quoteAsset,
            ticker: symbol.symbol,
            //exchange: 'Binance',
            //listed_exchange: 'Binance',
            //type: 'crypto',
            session: '24x7',
            minmov: 1,
            pricescale: pricescale(symbol),
            timezone: 'UTC+8',
            has_intraday: true,
            // intraday_multipliers: ['1', '60'],
            has_daily: true,
            has_weekly_and_monthly: true,
            currency_code: symbol.quoteAsset,
            // from_symbol: symbol.baseAsset,
            // to_symbol: symbol.quoteAsset,
          });
        }, 0);
        return;
      }
    }

    onResolveErrorCallback('not found');
  }

  getBars(
    symbolInfo,
    resolution,
    from,
    to,
    onHistoryCallback,
    onErrorCallback,
    firstDataRequest
  ) {
    // console.log(resolution);
    // console.log('getbar:' + from);
    console.log(new Date(from * 1000).toISOString());
    // console.log('getbar:' + to);
    console.log(new Date(to * 1000).toISOString());

    var offset = 0;
    if (resolution != '1D') {
      offset = resolution * 2500 * 60;
      var diff = to - from;
      if (diff < offset) {
        from = to - offset;
      }
    }
    // console.log(offset);
    // console.log('=====getBars running');
    // console.log('function args',arguments)
    // console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)
    let url =
      'https://api.binance.com/api/v3/klines?symbol=' +
      symbolInfo.name +
      '&interval=' +
      intervals[resolution] +
      '&startTime=' +
      from * 1000 +
      '&endTime=' +
      to * 1000 +
      '&limit=1000';
    // console.log(url);
    fetch(url)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        // console.log(json[json.length - 1][0]);
        // console.log('json1');
        // console.log(json);
        let new_start_time = json[json.length - 1][0];
        let url2 =
          'https://api.binance.com/api/v3/klines?symbol=' +
          symbolInfo.name +
          '&interval=' +
          intervals[resolution] +
          '&startTime=' +
          new_start_time +
          '&endTime=' +
          to * 1000 +
          '&limit=1000';
        fetch(url2)
          .then((res2) => {
            return res2.json();
          })
          .then((json2) => {
            // console.log('json2');
            // console.log(json2);
            // let new_arr = json.concat(json2);
            // // console.log(new_arr);
            // const arr = new_arr.map((i) => formatingKline(i));
            // return arr;
            let new_start_time2 = json2[json2.length - 1][0];
            let url3 =
              'https://api.binance.com/api/v3/klines?symbol=' +
              symbolInfo.name +
              '&interval=' +
              intervals[resolution] +
              '&startTime=' +
              new_start_time2 +
              '&endTime=' +
              to * 1000 +
              '&limit=1000';
            fetch(url3)
              .then((res3) => {
                return res3.json();
              })
              .then((json3) => {
                let new_arr = json.concat(json2).concat(json3);
                // console.log('json');
                // console.log(json);
                // console.log('json2');
                // console.log(json2);
                // console.log('json3');
                // console.log(json3);
                new_arr = _.uniq(new_arr);
                // console.log(new_arr);
                const arr = new_arr.map((i) => formatingKline(i));
                return arr;
              })
              .then((klines) => {
                if (klines.length) {
                  onHistoryCallback(klines, { noData: false });
                } else {
                  onHistoryCallback(klines, { noData: true });
                }
              });
          });
      })
      .catch((err) => {
        console.log(err);
        onErrorCallback(err);
      });
    // historyProvider
    //   .getBars(symbolInfo, resolution, from, to, firstDataRequest)
    //   .then((bars) => {
    //     if (bars.length) {
    //       onHistoryCallback(bars, { noData: false });
    //     } else {
    //       onHistoryCallback(bars, { noData: true });
    //     }
    //   })
    //   .catch((err) => {
    //     console.log({ err });
    //     onErrorCallback(err);
    //   });
  }
  subscribeBars(
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscribeUID,
    onResetCacheNeededCallback
  ) {
    let request = {
      method: 'SUBSCRIBE',
      params: [
        symbolInfo.name.toLowerCase() + '@kline_' + intervals[resolution],
      ],
      id: 1,
    };
    ws.send(JSON.stringify(request));
    last_stream = {
      name: symbolInfo.name.toLowerCase() + '@kline_' + intervals[resolution],
      callback: onRealtimeCallback,
    };

    // ws.onopen = () => {
    // let request = {
    //   method: 'SUBSCRIBE',
    //   params: ['btcusdt@kline_1m'],
    //   id: 1,
    // };
    // ws.send(JSON.stringify(request));
    // };
    // console.log('=====subscribeBars runnning');
    // stream.subscribeBars(
    //   symbolInfo,
    //   resolution,
    //   onRealtimeCallback,
    //   subscribeUID,
    //   onResetCacheNeededCallback
    // );
  }
  unsubscribeBars(subscriberUID) {
    let param = last_stream;
    if (param && param.name) {
      let request = {
        method: 'UNSUBSCRIBE',
        params: [param.name],
        id: 1,
      };
      ws.send(JSON.stringify(request));
    }
    // console.log('=====unsubscribeBars running');
    // stream.unsubscribeBars(subscriberUID);
  }
  // calculateHistoryDepth(resolution, resolutionBack, intervalBack) {
  //   //optional
  //   // console.log('=====calculateHistoryDepth running');
  //   // while optional, this makes sure we request 24 hours of minute data at a time
  //   // CryptoCompare's minute data endpoint will throw an error if we request data beyond 7 days in the past, and return no data
  //   return resolution < 60
  //     ? { resolutionBack: 'D', intervalBack: '1' }
  //     : undefined;
  // }
  // getMarks(symbolInfo, startDate, endDate, onDataCallback, resolution) {
  //   //optional
  //   // console.log('=====getMarks running');
  // }
  // getTimeScaleMarks(
  //   symbolInfo,
  //   startDate,
  //   endDate,
  //   onDataCallback,
  //   resolution
  // ) {
  //   //optional
  //   // console.log('=====getTimeScaleMarks running');
  // }
  // getServerTime(cb) {
  //   // console.log('=====getServerTime running');
  // }
}
